import React from 'react';
import Hero from '../components/home/Hero';
import PopularProducts from '../components/home/PopularProducts';
import Features from '../components/home/Features';
// import Stats from '../components/home/Stats';
import FAQ from '../components/home/FAQ';
import './Home.css';

function Home() {
  return (
    <div className="home-page">
      <Hero />
      <PopularProducts />
      <Features />
      {/* <Stats /> */}
      <FAQ />
    </div>
  );
}

export default Home;
